import { getZrmUserInfo } from '@zg-rentals/clickstream';
import { trackUserEvent } from '.';
import type { ZrmClickstreamUser } from '@zg-rentals/clickstream';

// https://dataportal.zillowgroup.net/event-registry/7291
export const emitEmptyStatePageViewEvent = (user: ZrmClickstreamUser) =>
  trackUserEvent({
    envelope: {
      event_type_id: '7291',
      event_type_version_id: '1',
      event_template_id: '171',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'view',
      trigger_location_nm: 'navigation',
      trigger_source_nm: 'navigation',
      trigger_object_nm: 'no_trigger_object',
    },
    semantic: {
      semantic_event_nm: 'view_content',
      topic_tag_txt: ['zrm_payments'],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/7298
export const emitClickStartCollectingRentButtonEvent = (user: ZrmClickstreamUser) =>
  trackUserEvent({
    envelope: {
      event_type_id: '7298',
      event_type_version_id: '1',
      event_template_id: '172',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'agg_view_empty_state_page',
      trigger_source_nm: 'start_collecting_rent_button',
      trigger_object_nm: 'agg_view_empty_state_page',
    },
    semantic: {
      semantic_event_nm: 'click_start_collecting_rent',
      topic_tag_txt: ['zrm_payments'],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/7299
export const emitClickAddNewPropertyEvent = (user: ZrmClickstreamUser) =>
  trackUserEvent({
    envelope: {
      event_type_id: '7299',
      event_type_version_id: '1',
      event_template_id: '173',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'agg_view_empty_state_page',
      trigger_source_nm: 'agg_view_add_a_property_button',
      trigger_object_nm: 'start_collecting_rent_modal',
    },
    semantic: {
      semantic_event_nm: 'click_add_property',
      topic_tag_txt: ['zrm_payments'],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/7300
export const emitClickContinueEvent = (user: ZrmClickstreamUser) =>
  trackUserEvent({
    envelope: {
      event_type_id: '7300',
      event_type_version_id: '1',
      event_template_id: '174',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'agg_view_empty_state_page',
      trigger_source_nm: 'agg_view_start_collecting_continue_button',
      trigger_object_nm: 'start_collecting_rent_modal',
    },
    semantic: {
      semantic_event_nm: 'click_continue',
      topic_tag_txt: ['zrm_payments'],
    },
    ...getZrmUserInfo(user),
  });
